<template>
  <b-overlay :show="loader" rounded="sm">
    <div class="d-flex vh-100 bg-primary">
      <b-card
        class="
          bg-white
          py-6
          px-4
          shadow
          sm:rounded-lg sm:px-10
          text-gray-700
          dark:text-gray-200
          col-lg-5
          b-card-main
        "
      >
        <b-card-text class="mt-3">
          <h4><b>Welcome</b></h4>
          <p class="text-muted font-weight-semi-bold">Register your account</p>
        </b-card-text>
        <ValidationObserver ref="observer">
          <b-form
            slot-scope="{ validate }"
            @submit.prevent="validate().then(onSubmit)"
          >
            <ValidationProvider rules="required" name="Username">
              <b-form-group
                label="User Name"
                class="mt-5 b-form-group"
                slot-scope="{ valid, errors }"
              >
                <b-form-input
                  type="text"
                  v-model="user.userName"
                  :state="errors[0] ? false : valid ? true : null"
                  placeholder="Enter username"
                />
                <b-form-invalid-feedback>
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>

            <ValidationProvider rules="required|email" name="Email address">
              <b-form-group
                label="Email Address"
                class="mt-4 b-form-group"
                slot-scope="{ valid, errors }"
              >
                <b-form-input
                  type="email"
                  v-model="user.emailAddress"
                  :state="errors[0] ? false : valid ? true : null"
                  placeholder="Enter email address"
                />
                <b-form-invalid-feedback>
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>

            <ValidationProvider rules="required" name="Password" vid="password">
              <b-form-group
                class="mt-4 b-form-group"
                label="Password"
                slot-scope="{ valid, errors }"
              >
                <b-form-input
                  type="password"
                  v-model="user.password"
                  :state="errors[0] ? false : valid ? true : null"
                  placeholder="Enter password"
                />
                <b-form-invalid-feedback>
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>

            <ValidationProvider
              rules="required|confirmed:password"
              name="Confirm Password"
            >
              <b-form-group
                class="mt-4 b-form-group"
                label="Confirm Password"
                slot-scope="{ valid, errors }"
              >
                <b-form-input
                  type="password"
                  v-model="user.confirmPassword"
                  :state="errors[0] ? false : valid ? true : null"
                  placeholder="Enter confirm password"
                />
                <b-form-invalid-feedback>
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>

            <b-form-group class="mt-5">
              <b-button
                type="submit"
                variant="primary"
                class="signup-btn"
                block
              >
                Sign Up
              </b-button>
            </b-form-group>
            <b-card-text class="mt-3 mb-2" style="text-align: left"
              >Already have an account?
              <router-link
                class="font-weight-bold font-size-3 ml-2"
                :to="{ name: 'Login' }"
                style="text-decoration: none"
              >
                Sign in!
              </router-link>
            </b-card-text>
          </b-form>
        </ValidationObserver>
      </b-card>
    </div>
  </b-overlay>
</template>
<script>
import {
  ValidationObserver,
  ValidationProvider,
} from "vee-validate/dist/vee-validate.full";
import {
  BForm,
  BFormGroup,
  BFormInput,
  BCard,
  BCardText,
  BButton,
} from "bootstrap-vue";
import { USER_SIGNUP } from "../../../graphql/auth";
import { toastification } from "../../../@core/mixins/toastification";
import useJwt from "../../../auth/jwt/useJwt";
export default {
  name: "login",
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BCard,
    BCardText,
    BButton,
    ValidationObserver,
    ValidationProvider,
  },
  data: () => ({
    user: {
      userName: "",
      emailAddress: "",
      password: "",
      confirmPassword: "",
    },
    loader: false,
  }),
  mixins: [toastification],
  methods: {
    resetFiled() {
      this.user.userName = "";
      this.user.emailAddress = "";
      this.user.password = "";
      this.user.confirmPassword = "";
    },
    onSubmit() {
      this.loader = true;
      // return new Promise((response, reject) => {
      //   try {
      //     this.$apollo
      //       .mutate({
      //         mutation: USER_SIGNUP,
      //         variables: {
      //           userName: this.user.userName,
      //           emailAddress: this.user.emailAddress,
      //           password: this.user.password,
      //         },
      //       })
      //       .then(({ userList }) => {
      //         response(userList);
      //         this.makeToastSuccess("Sucessfully Register");
      //       });
      //     this.resetFiled();
      //   } catch (err) {
      //     reject(err);
      //     this.makeToastFail(err);
      //   }
      // });
      if (
        this.user.userName !== "" &&
        this.user.emailAddress !== "" &&
        this.user.password !== "" &&
        this.user.confirmPassword !== ""
      ) {
        this.$apollo
          .mutate({
            mutation: USER_SIGNUP,
            variables: {
              userName: this.user.userName,
              emailAddress: this.user.emailAddress,
              password: this.user.password,
            },
          })
          .then((userList) => {
            useJwt.setUserName(userList.data.signUp.username);
            // response(userList);
            // setTimeout(() => {
            //   this.makeToastSuccess(
            //     `Sucessfully Register, Please login ${userList.data.signUp.username}`,
            //     2000
            //   );
            // }, 3000);
            this.loader = false;
            this.$router.push("/");
            this.resetFiled();
          })
          .catch((err) => {
            this.loader = false;
            this.makeToastFail(err);
          });
      }
    },
  },
};
</script>
<style scoped>
@media only screen and (max-height: 900px) {
  .vh-100 {
    height: auto !important;
  }
}

.b-card-main[data-v-c4fc0512] {
  margin: auto;
  margin-top: 0rem;
}
.b-card-main {
  max-width: 30rem;
  margin: auto;
  margin-top: 5rem;
  height: auto;
}
.b-form-group {
  text-align: left;
}
.signup-btn {
  width: 100%;
  border-radius: 1rem;
  padding-bottom: 0.75rem;
  padding-top: 0.75rem;
}
</style>
